
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetQuery from "./helper/useGetQuery"
import useUpdateMutationById from "./helper/useUpdateMutationById";

  const API = {
    GET: "/api/admin/works",
    ADD: "/api/admin/works",
    UPDATE: "/api/admin/works",
    DELETE: "/api/admin/works",
  };

  const KEY = "WORKS";
  export const useGetWorks = (params?:any) => useGetQuery(KEY, API.GET, params);
  export const useAddWorks = () => useAddMutation(KEY, API.ADD);
  export const useUpdateWorks = () => useUpdateMutationById(KEY, API.UPDATE);
  export const useDeleteWorks = () =>useDeleteMutation(KEY, API.DELETE);
